import MainContainer from 'modules/common/MainContainer';
import DiscountsView from 'modules/discounts/views';

const PharmacyDiscountsPage = () => (
  <MainContainer context="Discounts">
    <DiscountsView />
  </MainContainer>
);

PharmacyDiscountsPage.propTypes = {};

PharmacyDiscountsPage.defaultProps = {};

export default PharmacyDiscountsPage;
